export default "__VITE_ASSET__jyg2JmrU__"